// extracted by mini-css-extract-plugin
export default {"root":"AddFieldMappingDropdown_root__jrlF9","trigger":"AddFieldMappingDropdown_trigger__s2B5E"};